var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8039 1.9728L4.71328 12.0634L1.14589 8.49605C0.977027 8.32718 0.703225 8.32718 0.534324 8.49605L0.126649 8.90372C-0.0422162 9.07259 -0.0422162 9.34639 0.126649 9.51529L4.40751 13.7962C4.57638 13.965 4.85018 13.965 5.01908 13.7962L15.8232 2.99208C15.992 2.82322 15.992 2.54942 15.8232 2.38051L15.4154 1.9728C15.2466 1.80394 14.9728 1.80394 14.8039 1.9728Z",
    id: "tick-svg",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.96886c4dd71de9d1bc0178ddc7748940.svg";
export { ForwardRef as ReactComponent };